import SyncBox from "./SyncBox";
import { generateSyncBoxId } from "./utils";
export default class SyncBoxFactory {
    static instances = new Map();
    static getInstance(config) {
        const syncBoxId = generateSyncBoxId(config);
        if (!this.instances.has(syncBoxId)) {
            this.instances.set(syncBoxId, new SyncBox(config));
        }
        return this.instances.get(syncBoxId);
    }
    static clearInstances() {
        this.instances.clear();
    }
}
